export default {
    list: {
        title: "Regroupements",
        name: 'regroupements',
        class: "min-h-screen flex-1 mt-1 bg-gray-100 px-3 items-center",
        options: {
            defaultPageSize: 5,
            actions: {
                isActive: true,
                name: "Actions",
                buttons: [{
                    text: "Add regroupement",
                    icon: "add",
                    link: '/regroupements/new',
                    color: 'primary'
                }],
            }
        },
        columns: [{
                name: "name",
                elements: [{
                    items: [{
                        class: "",
                        name: "name",
                        type: "text",

                    }, ],
                }, ]
            },
            {
                name: "warehouses",
                elements: [{
                    items: [{
                        class: "",
                        name: "warehouses",
                        type: "text",

                    }, ],
                }, ]
            },
        ],
        actions: {
            name: "actions",
            width: "10px",
            class: "justify-center",
            elements: [{
                    icone: "edit",
                    color: "success",
                    role: true,
                    key: 'update',
                    link: '/regroupements/edit',
                    tooltip: "Update",
                },
                {
                    icone: "delete",
                    color: "danger",
                    role: true,
                    key: 'delete',
                    tooltip: "Delete",
                }
            ],
        },
        filters: {
            name: 'regroupements',
            elements: {
                search: {
                    options: {
                        icon: "search",
                        label: "search",
                        class: "",
                        hint: "Search regroupement ...",
                    },
                    value: null,
                    type: "search",
                    validate: {
                        trim: true,
                        required: false,
                        minlength: 0,
                    }
                },
                champs: [],
            },
        },
    },
}